const environments = {
  development: {
    CHECKOUT_URL: 'http://localhost:8001',
  },
  staging: {
    CHECKOUT_URL: 'https://ramp.qdx.ninja',
  },
  production: {
    CHECKOUT_URL: 'https://ramp.quidax.io',
  },
};

// @ts-ignore
export default environments['CONFIG.NODE_ENV'] || environments.production;
